/** Request com os dados para realizar a liberação dos pedidos não liberados */
export class PedidoLiberarRequest {
    ids: number[];
    justificativaLiberado: string;

    constructor(id: number = null) {
        this.ids = [];
        if (id) {
            this.ids.push(id);
        }
    }
}
